module.exports = __webpack_public_path__ + "img/QR_lg.83354e9e.png";